// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"0232526e","808":"fe9d79ca"}[chunkId] + ".chunk.js";
};